import React from 'react';
import LandingPage from './LandingPage';

const LandingContainer = () => {
    return (
        <>
        <LandingPage />
        </>
    )
}

export default LandingContainer;